import TextTooltip from './TextTooltip';

export default TextTooltip;
